import ApiBaseModel from "@/common/models/ApiBaseModel";

export default class PreferenceModel extends ApiBaseModel {
    defaultCategoryId:     string = "";
    
    static from(json: string): PreferenceModel {        
        return Object.assign(new PreferenceModel(), json);
    }
}